import React from 'react';
import { useToken } from '@samc/auth-authentication-okta';
import { useClient, useCurrentUser } from '@samc/auth-authorization';
import '@samc/centricity-core/dist/style.css';
import "@samc/auth-authorization/index.css";
import "@samc/auth-authentication-okta/index.css";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Admin from "./Admin.react";

const ShowMainContent = () => {
  document.getElementById('body').classList.remove('hidden');
  document.getElementById('body').classList.add('flex');
  return <React.Fragment />;
}

const HomeRedirect = () => {
    const client = useClient();
    // Ping AuthAPI to refresh user's data from Okta once they're logged in
    client.refreshUserInfo().then(_ => {
        window.location.href = '/TransactionManagement';
    });
    return <React.Fragment />;
}

export const SiteContent = () => {
    const token = useToken();
    const user = useCurrentUser();
    const client = useClient();
    const userCanAccessSystem = token !== null && user.isLoaded && user.termsOfUseAcceptance;
    // Only when a user is truly ready (they're logged in and they've accepted terms) can we show them things like the menu bar and whatnot, which is controlled by the 'ready' class.
    document.body.classList.toggle('ready', userCanAccessSystem);

    // If they're not ready, the Authentication or Authorization component is likely still controlling the content, so we probably won't hit this. 
    // Nevertheless, just in case, we bail.
    if (!userCanAccessSystem) {
        return <React.Fragment />;
    }

    window.__authClient = client;
    return (
        <Router>
            <Switch>
                <Route path="/admin">
                    <Admin />
                </Route>
                <Route exact path="/">
                    <HomeRedirect />
                </Route>
                <Route path="/*">
                    <ShowMainContent />
                </Route>
            </Switch>
        </Router>
    );
}